"use client";

import { useRef, useEffect, useState } from "react";
import Slider, { Settings } from "react-slick";
import Image from "next/image";
import arrowLeft from "../../lib/carousel/arrow_left.png";
import arrowRight from "../../lib/carousel/arrow_right.png";
const styles = new Proxy({"ValuesCards":"ValuesCards-eb903","Inner":"Inner-eb903","Timeline":"Timeline-eb903","TimelineDotsRow":"TimelineDotsRow-eb903","TimelineLine":"TimelineLine-eb903","TimelineDotCell":"TimelineDotCell-eb903","TimelineDotOuter":"TimelineDotOuter-eb903","TimelineDotInner":"TimelineDotInner-eb903","CardsRow":"CardsRow-eb903","CarouselWrap":"CarouselWrap-eb903","SlideOuter":"SlideOuter-eb903","Card":"Card-eb903","Controls":"Controls-eb903","Dots":"Dots-eb903","Dot":"Dot-eb903","DotActive":"DotActive-eb903","ArrowBtn":"ArrowBtn-eb903","CardTitle":"CardTitle-eb903","Subtext":"Subtext-eb903"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });
/*import "./ValuesCardsSlider.scss";*/
import { RichText } from "payload-pms/RichText";
import { SerializedEditorState } from "@payloadcms/richtext-lexical/lexical";

interface ValueCard {
  title: string;
  content?: SerializedEditorState;
}

export default function ValuesCardsCarousel({ cards }: { cards: ValueCard[] }) {
  const sliderRef = useRef<Slider>(null);
  const [active, setActive] = useState(false);
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const check = () => setActive(window.innerWidth < 576);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  if (!active) return null;

  const SETTINGS: Settings = {
    dots: false,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    swipeToSlide: true,
    speed: 300,
    cssEase: "ease",
    afterChange: (index) => setCurrent(index),
  };

  return (
    <div className={styles.CarouselWrap}>
      <Slider ref={sliderRef} {...SETTINGS} className="ValuesCardsSlider">
        {cards.map((card, i) => (
          <div key={i} className={styles.SlideOuter}>
            <div className={styles.Card}>
              <h3 className={styles.CardTitle}>{card.title}</h3>
              {card.content && <RichText content={card.content} />}
            </div>
          </div>
        ))}
      </Slider>
      <div className={styles.Controls}>
        <button
          className={styles.ArrowBtn}
          onClick={() => sliderRef.current?.slickPrev()}
          aria-label="Previous"
        >
          <Image src={arrowLeft} alt="Previous" width={20} height={29} />
        </button>
        <ul className={styles.Dots}>
          {cards.map((_, i) => (
            <li
              key={i}
              className={
                i === current % cards.length ? styles.DotActive : styles.Dot
              }
              onClick={() => sliderRef.current?.slickGoTo(i)}
            />
          ))}
        </ul>
        <button
          className={styles.ArrowBtn}
          onClick={() => sliderRef.current?.slickNext()}
          aria-label="Next"
        >
          <Image src={arrowRight} alt="Next" width={20} height={29} />
        </button>
      </div>
    </div>
  );
}
